<template>
    <div class="builder-wrapper" :class="{'menu-open': menuOpen}">
        <div class="menu">
            <span class="menu-link" @click="menuOpen=!menuOpen"><i class="fas" :class="{'fa-bars': !menuOpen, 'fa-times': menuOpen}"></i></span>
            <img class="logo" src="../../../assets/logo.png"/>

            <div class="menu-options">
                <router-link :to="{name: 'Welcome'}" class="active"><i class="fas fa-home" style="margin: 0;"></i></router-link>
                <router-link :to="{name: 'Store'}"><i class="fas fa-shopping-cart"></i> Kit Store</router-link>
                <router-link :to="{name: 'Builder'}"><i class="fas fa-toolbox"></i> Kit Builder</router-link>
                <router-link :to="{name: 'Director'}"><i class="fas fa-bullhorn"></i> Escape It Director</router-link>
                <!--<a><i class="fas fa-user"></i></a>-->
                <a @click="logout()"><i class="fas fa-power-off"></i></a>
            </div>
        </div>

        <div class="welcome-frame">
            <div>
                <div class="steps-frame">
                    <div class="step" @click="goto('Store')">
                        <i class="far fa-shopping-cart icon"></i>
                        <h2>Step 1</h2>
                        <h4>Purchase a Kit</h4>
                        <div class="instructions">
                            Check out all the awesome Escape Room Kits you can build in the <strong>Kit Store</strong>!
                        </div>
                    </div>
                    <div class="step" @click="goto('Builder')">
                        <i class="far fa-toolbox icon"></i>
                        <h2>Step 2</h2>
                        <h4>Build & Customize</h4>
                        <div class="instructions">
                            Create your own custom build of your Escape Room Kits using the <strong>Kit Builder</strong>.
                        </div>
                    </div>
                    <div class="step" @click="goto('Director')">
                        <i class="far fa-bullhorn icon"></i>
                        <h2>Step 3</h2>
                        <h4>Run your Escape Room</h4>
                        <div class="instructions">
                            Kit built and ready to go use the <strong>Escape It Director</strong> to run your Escape Room.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import auth from '../../../services/auth';
    import router from "../../../router";

    export default {
        name: "welcome",
        data: function () {
            return {
                menuOpen: false
            }
        },
        methods: {
            goto(location) {
                router.push({name: location});
            },
            logout() {
                auth.logout();
            }
        },
        computed: {
            options: function () {
                let options = [];
                let builds = this.$store.getters['user/builds'];
                for (let i = 0; i < builds.length; i++) {
                    let build = builds[i];
                    options.push({value: build, text: build.title});
                }
                return options;
            },
            kits: function () {
                return this.$store.getters['user/kits'];
            },
            builds: function () {
                return this.$store.getters['user/builds'];
            },
            user: function () {
                return this.$store.getters['user/user'];
            }
        }
    }

</script>

<style lang="scss" scoped>
    .builder-wrapper {
        font-family: "Roboto", sans-serif;

        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        .menu {
            margin: 0 auto;

            .logo {
                padding: 12px 0 0 10px;
                float: left;

                img {
                    max-width: 179px;
                    width: 100%;
                }

                @media (max-width: 770px) {
                    float: right;
                    margin-right: 16px;
                }
            }

            .menu-link {
                float: left;
                padding: 20px 0 0 20px;
                display: none;

                i {
                    font-size: 26px;
                }

                @media (max-width: 770px) {
                    display: inline-block;
                }
            }

            .menu-options {
                position: absolute;
                right: 0;

                a {
                    display: inline-block;
                    padding: 20px;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 0.50);
                    height: 65px;

                    i {
                        font-size: 22px;
                        margin-right: 10px;
                        color: rgba(255, 255, 255, 0.50);
                    }

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.30);
                        text-decoration: none;
                    }

                    &.active {
                        box-shadow: inset 0 3px 0 #e45114;
                        background-color: rgba(16, 16, 16, 0.98);
                        color: white;
                        i {
                            color: white;
                        }

                    }
                }

                @media (max-width: 770px) {
                    display: none;
                }
            }
        }

        .welcome-frame {
            margin: 0 auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 65px;
            bottom: 0;

            background: #111 url('../../../assets/dark_cartographer_bg.png');

            .steps-frame {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row;

                margin-top: 10%;

                .step {
                    position: relative;

                    font-family: "Roboto", sans-serif;
                    margin: 15px;

                    text-align: center;
                    min-height: 233px;
                    width: 25%;
                    min-width: 200px;
                    max-width: 350px;

                    border: 1px solid #017AFF;
                    background: rgba(1, 122, 255, 0.15);

                    cursor: pointer;
                    display: inline-block;
                    float: left;

                    padding: 20px;

                    i.icon {
                        margin: 20px 0 30px;
                        font-size: 48px;
                    }

                    h2 {
                        font-size: 24px;
                        margin-bottom: 10px;
                    }
                    h4 {
                        font-size: 16px;
                    }

                    .instructions {
                        padding: 10px 15px 20px;
                        font-size: 14px;
                        color: rgba(255,255,255,0.5);

                        strong {
                            color: white;
                        }
                    }
                }
            }


        }

        &.menu-open {
            .welcome-frame {
                .side-menu {
                    display: block;
                    z-index: 1000;
                    background: black;

                    -webkit-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    -moz-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);

                    transition: left 0.5s;

                    .menu-options ul li:last-child {
                        border-right: 0;
                    }
                }
                .content-frame {
                    /*display: none;*/
                    /*opacity: 0.4;*/
                }

            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/app/welcome/welcome.vue